export const NotFound = () => {
  return (
    <div className="flex h-dvh items-center justify-center bg-chorus-black-500 text-white">
      404 Not found
    </div>
  );
};
